<template>
  <div class="app-container" style="padding-left: 0px; padding-right: 0px;">
    <el-row :gutter="24">
      <el-col :span="6" :xs="24" >
        <div class="head-container">
          <el-input
              v-model="departmentName"
              placeholder="请输入查找字符"
              clearable
              size="small"
              prefix-icon="el-icon-search"
              style="margin-bottom: 20px"
          />
        </div>
        <div class="head-container">
          <el-tree style="margin-bottom:10px;"
              class="flow-tree"
              :data="treeData"
              :props="defaultProps"
              :expand-on-click-node="false"
              :filter-node-method="filterNode"
              ref="tree"
              default-expand-all
              @node-click="handleNodeClick"
              highlight-current
          >
<!--                    <span class="custom-tree-node" slot-scope="{ node, data }">-->
<!--                      <span>{{ node.label }}</span>-->
<!--                      <el-tooltip class="item" effect="dark" :content="'编制：'+data.planCount+'人,在编：'+showRealCount(data)+'人,缺编：'+(data.planCount-data.realCount)+'人'" placement="top-end">-->
<!--                        <span v-if="data.planCount" style="color: #c75151">{{showRealCount(data)}}-->
<!--                        </span>-->
<!--                      </el-tooltip>-->
<!--                      <el-tooltip class="item" effect="dark" :content="'编制：-人,在编：'+showRealCount(data)+'人,缺编：-人'" placement="top-end">-->
<!--                        <span v-if="!data.planCount">{{showRealCount(data)}}</span>-->
<!--                      </el-tooltip>-->
<!--                    </span>-->
          </el-tree>
        </div>
      </el-col>

      <el-col :span="18" :xs="24">
        <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px">
<!--          <el-form-item label="">-->
<!--            <el-checkbox v-model="queryParams.isShowDeleted" size="small" @change="handleQuery">只看删除人员</el-checkbox>-->
<!--          </el-form-item>-->
          <!-- <el-form-item  label="">
            <el-checkbox v-model="queryParams.isShowDepart" size="small" @change="handleQuery">显示离职人员</el-checkbox>
          </el-form-item>
          <el-form-item  label="">
            <el-checkbox v-model="queryParams.noSalary" size="small" @change="handleQuery">只看未定薪人员</el-checkbox>
          </el-form-item> -->
          <el-form-item label="姓名" prop="name">
              <el-input v-model="queryParams.name" placeholder="姓名" clearable size="small" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="员工状态" prop="empStatus">
            <el-select v-model="queryParams.empStatus" style="width:100%;" placeholder="请选择员工状态" clearable>
              <el-option  v-for="dict in employeeStatuses" :key="dict.value" :label="dict.label" :value="dict.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号" prop="idNum">
            <el-input
                v-model="queryParams.idNum"
                placeholder="请输入身份证号码"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="总工资">
              <div style="width:400px;">
              <el-col :span="6">
                <el-input v-model="queryParams.contractSalaryStart" placeholder="大于" clearable size="small" @keyup.enter.native="handleQuery" />
              </el-col>
              <el-col :span="1">至</el-col>
              <el-col :span="6">
                <el-input v-model="queryParams.contractSalaryEnd" placeholder="小于" clearable size="small" @keyup.enter.native="handleQuery" />
              </el-col>
              </div>
               <!-- <el-slider style="width:200px;"
                  v-model="salaryRange"
                  range
                  :marks="marks">
                </el-slider> -->

          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
<!--            <el-button v-if="opType!='hrEntry' && officalCount >= 0"-->
<!--                       type="primary"-->
<!--                       plain-->
<!--                       icon="el-icon-s-release"-->
<!--                       size="mini"-->
<!--                       :disabled="officalCount <= 0"-->
<!--                       @click="listOffical"-->
<!--                       v-permission="['/cb/cbSalarySetting/add']"-->
<!--            >{{officalCount}}人待定薪-->
<!--            </el-button>-->
          </el-form-item>
          <el-form-item  label="">
            <el-checkbox v-model="queryParams.isShowDepart" size="small" @change="handleQuery">显示离职人员</el-checkbox>
          </el-form-item>
          <el-form-item  label="">
            <el-checkbox v-model="queryParams.noSalary" size="small" @change="handleQuery">只看未定薪人员</el-checkbox>
          </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button type="primary" plain icon="el-icon-edit" size="mini"
                @click="handleMultiSalary" v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']" >批量设置总工资
            </el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" plain icon="el-icon-edit" size="mini"
                       @click="handleMultiSalaryTemplate" v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']" >批量设置账套
            </el-button>
          </el-col>
          <el-col :span="1.5">
            <el-upload v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']"
                       action
                       :name="form.url"
                       class="upload-demo"
                       ref="upload"
                       :limit="1"
                       :http-request="importSocialSecurity"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove"
                       :file-list="fileList"
                       accept=".xls,.xlsx"
                       :auto-upload="true">
              <el-button slot="trigger" size="mini" type="warning" plain :class="{uniAppMarginBottom:uniApp,webMarginBottom:!uniApp }">导入社保</el-button>
            </el-upload>
<!--            <el-button type="primary" plain icon="el-icon-edit" size="mini"-->
<!--                       @click="importSocialSecurity" v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']" >导入社保-->
<!--            </el-button>-->
          </el-col>
          <el-col :span="1.5">
            <el-upload v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']"
                       action
                       :name="form.url"
                       class="upload-demo"
                       ref="upload"
                       :limit="1"
                       :http-request="importFund"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove"
                       :file-list="fileList"
                       accept=".xls,.xlsx"
                       :auto-upload="true">
              <el-button slot="trigger" size="mini" type="warning" plain :class="{uniAppMarginBottom:uniApp,webMarginBottom:!uniApp }">导入公积金</el-button>
            </el-upload>
<!--            <el-button type="primary" plain icon="el-icon-edit" size="mini"-->
<!--                       @click="importFund" v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']" >导入公积金-->
<!--            </el-button>-->
          </el-col>
          <el-col :span="1.5">
            <el-upload v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']"
                       action
                       :name="form.url"
                       class="upload-demo"
                       ref="upload"
                       :limit="1"
                       :http-request="importSalary"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove"
                       :file-list="fileList"
                       accept=".xls,.xlsx"
                       :auto-upload="true">
              <el-button slot="trigger" size="mini" type="warning" plain :class="{uniAppMarginBottom:uniApp,webMarginBottom:!uniApp }">导入薪资</el-button>
            </el-upload>
<!--            <el-button type="primary" plain icon="el-icon-edit" size="mini"-->
<!--                       @click="importSalary" v-permission="['/cb/cbSalarySetting/add','/cb/cbSalarySetting/edit']" >导入薪资-->
<!--            </el-button>-->
          </el-col>
          <el-col :span="1.5">
            <el-popover placement="top-start" title="个人薪资设置" width="350" trigger="click">
              <ul>
                <li>导入社保：导入社保后，可以更新工资计算中社保个人扣除金额，如果金额未变化可以不需要每月导入，会自动使用上次的金额进行扣除。导入金额为“0”则按照社保模板值扣除。</li>
                <li>导入公积金：导入公积金与导入社保类似。导入金额为“0”则按照公积金模板值扣除。</li>
                <li>导入薪资：导入总工资和银行卡信息。</li>
              </ul>
              <el-button type="primary" plain icon="el-icon-question" size="mini" slot="reference" >帮助</el-button>
            </el-popover>
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" plain icon="el-icon-download" size="mini" @click="downloadSocialSecurity" >下载社保模板
            </el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" plain icon="el-icon-download" size="mini" @click="downloadFund" >下载公积金模板
            </el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" plain icon="el-icon-download" size="mini" @click="downloadSalarySetting" >下载薪资设置模板
            </el-button>
          </el-col>
          <!--          <el-col :span="1.5">-->
          <!--            <el-button-->
          <!--                type="warning"-->
          <!--                plain-->
          <!--                icon="el-icon-download"-->
          <!--                size="mini"-->
          <!--                @click="handleExport"-->
          <!--                v-permission="['/employ/employ/export']"-->
          <!--            >导出-->
          <!--            </el-button>-->
          <!--          </el-col>-->
          <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
        </el-row>

        <el-table v-loading="loading" :data="employList" @selection-change="handleSelectionChange" style="width:100%" stripe border>
          <el-table-column type="selection" width="40" align="center"/>
          <!-- <el-table-column label="id" align="center" prop="id" width="60"  sortable >
          </el-table-column> -->
          <el-table-column label="姓名" align="center" prop="name" sortable width="auto" min-width="80"  :show-overflow-tooltip='true'>
            <template slot-scope="scope" >
              <el-button size="mini" type="text"
                         @click="handleView(scope.row)">
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="总工资" align="center" prop="contractSalary" sortable width="auto" min-width="120"  :show-overflow-tooltip='true'/>
          <el-table-column label="工资账套" align="center" sortable width="auto" min-width="180" prop="salaryTempId">
            <template slot-scope="scope" slot="header" sortable>
              <el-tooltip :aa="scope" class="item" effect="dark" placement="top" >
                <div slot="content">
                  <p>支付总工资=总工资(合同工资)+其他项(过节费等临时工资)<br>
                    总工资(合同工资)=工资(项目和)+浮动值(奖金等,只能有一个浮动值)<br>
                    所以也可以是：支付总工资=工资(项目和)+浮动值(奖金等,只能有一个浮动值)+其他项(社保公积金，过节费，水电代扣等工资项)</p><br>
                  <p>工资项目类型: <br>&nbsp;&nbsp;&nbsp;&nbsp;
                    "工资"是指一般工资项目, 比如基本工资, 补贴等这些固定值和系统计算的考勤扣除金额等. 考勤扣除项目不需要添加，系统自动计算 <br>&nbsp;&nbsp;&nbsp;&nbsp;
                    "浮动值"是指奖金项目, 它有且只能有一项, 它的值是由每位员工设置了总工资后, 由总工资减去所有工资项目和所得.<br>&nbsp;&nbsp;&nbsp;&nbsp;
                    "其他项"是不参与总工资计算浮动值的部分. 比如社保公积金，过节费，水电代扣等工资项</p><br>
                  <p>增减项: 是指此工资项目的运算是加还是减</p><br>
                  <p>值类型: "设置值"设置固定工资金额; "系统计算值"由系统计算得到,比如浮动工资奖金; "引用值"则是来源其他地方的设置,比如社保公积金等.</p><br>
                </div>
                <span>工资账套 ?</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">
<!--                  <SalaryEdit :salaryInfoIn="scope.row.salaryInfo" :editable="false" :salaryTempId="scope.row.salaryTempId" :contractSalary="scope.row.contractSalary"-->
<!--                              :companyIdIn="scope.row.companyId"></SalaryEdit>-->
                  <el-table :data="getSalaryItemInfo(scope.row)" show-summary :summary-method="getSummaries" stripe border>
                    <el-table-column label="项目名" align="center" prop="itemName">
                      <template slot-scope="scopeItem">
                        {{scopeItem.row.itemName}}
                      </template>
                    </el-table-column>
                    <el-table-column label="项目类型" align="center" prop="itemType">
                      <template slot-scope="scopeItem">
                        {{scopeItem.row.itemType}}
                      </template>
                    </el-table-column>
                    <el-table-column label="增减项" align="center" prop="plusMinus">
                      <template slot-scope="scopeItem">
                        {{scopeItem.row.plusMinus}}
                      </template>
                    </el-table-column>
                    <el-table-column label="考勤比例发放" align="center" prop="isAttend">
                      <template slot-scope="scopeItem">
                        {{scopeItem.row.isAttend?"是":"否"}}
                      </template>
                    </el-table-column>
                    <el-table-column label="金额(元)" align="center" prop="amount" width="88px">
                      <template slot-scope="scopeItem">
                        {{scopeItem.row.amount.toFixed(2)}}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <span v-if="scope.row.salarySelfDef">自定义工资</span>
                <span v-else>{{salaryTempFormat(scope.row, null)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="社保账号" align="center" prop="insuranceAcct" width="auto" min-width="100" :show-overflow-tooltip='true'/>
          <el-table-column label="社保个人缴费" align="center" prop="insuranceAmt" width="auto" min-width="100" :show-overflow-tooltip='true'/>
          <el-table-column label="公积金号" align="center" prop="fundAcct" width="auto" min-width="110" :show-overflow-tooltip='true'/>
          <el-table-column label="公积个人缴费" align="center" prop="fundAmt" width="auto" min-width="100" :show-overflow-tooltip='true'/>
          <el-table-column label="银行账号" align="center" prop="bankAcct" width="auto" min-width="100" :show-overflow-tooltip='true'/>
          <el-table-column label="银行名称" align="center" prop="bankName" width="auto" min-width="100" :show-overflow-tooltip='true'/>
          <el-table-column label="是否跨行" align="center" prop="isCrossBank" width="auto" min-width="80" :show-overflow-tooltip='true'/>
          <el-table-column label="跨行行名" align="center" prop="crossBankName" width="auto" min-width="100" :show-overflow-tooltip='true'/>
          <el-table-column label="工作证号" align="center" prop="workNum" sortable width="auto" min-width="150" :show-overflow-tooltip='true'/>
          <el-table-column label="公司" align="center" prop="companyId" sortable width="auto" min-width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              {{companyFormat(scope.row, null)}}
            </template>
          </el-table-column>
          <el-table-column label="部门" align="center" prop="departmentId" sortable width="auto" min-width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              {{departmentFormat(scope.row, null)}}
            </template>
          </el-table-column>
          <el-table-column label="岗位" align="center" prop="positionId" sortable width="auto" min-width="120" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              {{positionFormat(scope.row, null)}}
            </template>
          </el-table-column>
          <el-table-column label="员工状态" align="center" prop="empStatus" sortable width="auto" min-width="100"  :show-overflow-tooltip='true'/>
          <el-table-column label="员工类型" align="center" prop="empType" sortable width="auto" min-width="100"  :show-overflow-tooltip='true'/>
          <el-table-column label="用工形式" align="center" prop="empWorkType" sortable width="auto" min-width="100" :show-overflow-tooltip='true'/>

          <el-table-column label="证件类型" align="center" prop="idType" sortable width="auto" min-width="100" :show-overflow-tooltip='true'/>
          <el-table-column label="身份证号" align="center" prop="idNum"  sortable width="auto" min-width="180" :show-overflow-tooltip='true'/>
          <el-table-column label="首聘时间" align="center" prop="curPositionStartDate" sortable width="auto" min-width="150"  :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.curPositionStartDate, '{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="参加工作时间" align="center" prop="workStartDate" sortable width="auto" min-width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.workStartDate, '{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="入本单位时间" align="center" prop="joinCompanyDate" sortable width="auto" min-width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.joinCompanyDate, '{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="户口地" align="center" prop="householdAddr" sortable width="auto" min-width="150" :show-overflow-tooltip='true'/>
          <el-table-column label="集体户口" align="center" prop="householdType" sortable width="auto" min-width="100"/>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width" min-width="100" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-edit" v-if="!scope.row.contractSalary"
                         @click="handleUpdate(scope.row)" v-permission="['/cb/cbSalarySetting/add']" >定薪</el-button>
              <el-button size="mini" type="text" icon="el-icon-edit" v-if="scope.row.contractSalary"
                         @click="handleUpdate(scope.row)" v-permission="['/cb/cbSalarySetting/edit']" >调薪 </el-button>
<!--              <el-button size="mini" type="text" icon="el-icon-coin" v-if="scope.row.contractSalary"-->
<!--                         @click="viewTransferHis(scope.row)" v-permission="['/bpm/transferhis/findAll']"-->
<!--              > 调薪历史 </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </el-col>
    </el-row>
    <!-- 添加或修改岗位管理对话框 -->
    <el-dialog  :title="title" :visible.sync="open" width="85%" append-to-body>
      <SalarySettingEdit :row="row" :company-id="companyId" v-if="open" :isReadOnly="employReadOnly" @close="close"
                         @update="update"></SalarySettingEdit>
    </el-dialog>
    <el-dialog  title="批量设置工资账套" :visible.sync="openSalaryTemplate" width="60%" append-to-body>
      <div>
        <el-row>
          <el-col>
<!--          <el-form-item label="工资账套" :rules="[{ required: true, message: '必须选择工资账套', trigger: 'blur' }]">-->
            工资账套：<el-select v-model.number="salaryTemplateId" clearable placeholder="请选择工资账套">
              <el-option v-for="item in salaryTempListForSetting" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-col>
<!--          </el-form-item>-->
        </el-row>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button type="primary" @click="setSalaryTemplate">确 定</el-button>
          <el-button @click="openSalaryTemplate = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
<!--    <el-dialog  title="历史薪酬" :visible.sync="openTransferTrace" width="60%" append-to-body>-->
<!--      <HisTrace :userId="transferUserId" @close="openTransferTrace = false"></HisTrace>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import {importSocialSecurity,importFund,importSalary} from "@/api/cb/cbSalarySetting";
import { listEmploy,listEmployIncludeDelete, getEmploy, updateMultiSalary} from "@/api/employ/employ";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import RightToolbar from "@/components/RightToolbar"
import permission from '@/directive/permission/index.js' // 权限判断指令
import Pagination from "@/components/Pagination";
import {getTreeselectCompany} from "@/api/org/company";
import {getTreeselectDepartment} from "@/api/org/department";
import { getTreeselectPosition } from '@/api/org/position';
import {getOrgTree} from "../../org/components/orgtree";
import {DICT_TYPE,getDictLabelFromData, getDictDataLabel, getDictDatas} from "@/utils/dict";
import {sumTreeChild, getQueryParam} from "@/utils/tools";
import {formatDate} from "../../../../utils/formatTime";
import {checkRole} from "@/utils/role";
import SalarySettingEdit from "./salarySettingEdit";
import {listCbSalaryTemplate} from '@/api/cb/cbSalaryTemplate';
import SalaryEdit from "@/views/pages/cb/components/salaryEdit";
import {showLoading, hideLoading} from "../../../../utils/reqloading";

// 表查询配置
const dbOrderBy = ''

export default {
  name: "index",
  components: {
    Treeselect,
    RightToolbar,
    Pagination,
    SalarySettingEdit,
    SalaryEdit,
  },
  props: {
    //hrEntry 人事入职
    opType: {
      type: String,
      default: '',
    },
  },
  directives: {permission},
  data() {
    return {
      salaryTempList: [],
      treeData: [],
      openTransferTrace: false,
      transferUserId: null,
      isCompnayVisible: false,
      row: null,
      // opType: 'hr',
      // 是否显示弹出层
      open: false,
      // 弹出层标题
      title: "",
      // 遮罩层
      loading: true,
      // 查询参数
      where: {
        query: '',
        filters: []
      },

      companyId: 1,
      companyCode: 1,
      companyList: [],
      // 部门管理树选项
      departmentList: [],
      departmentOptions: [],
      positionList: [],
      positionOptions: [],
      // 公司树选项
      companyOptions: [],
      //
      postLevelOptions: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      departmentName: undefined,

      // 可以编辑的
      employReadOnly:false,
      employeeInfoAdd:false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 员工信息表格数据
      employList: [],
      // 今天到期待转正员工数
      officalCount: 0,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderby: dbOrderBy,
        name: null,
        empStatus: null,
        contractSalaryStart: null,
        contractSalaryEnd: null,
        workNum: null,
        idNum: null,
        companyId: null,
        companyCode: null,
        isShowDepart: false,
        isShowDeleted: false,
        noSalary: false,
      },
      salaryRange:[2000,20000],
      marks: {
          0: '2000',
          50: '10000',
          100:"20000"
          },
      employeeStatuses: DICT_TYPE.empOnWorkStatuses,//DICT_TYPE.employeeStatuses,
      openSalaryTemplate: false,
      salaryTempListForSetting:[],
      salaryTemplateId: null,

      form:{},
      fileList: [],
      uniApp:false,

    };
  },
  watch: {
    // 根据名称筛选部门树
    departmentName(val) {
      this.$refs.tree.filter(val);
    },
    // companyId(val){
    //   this.getDepartment(val);
    //   this.getPositison(val);
    // },
  },

  created() {
    // if(this.$store.getters.userInfo.constParentCompanyId == this.$store.getters.userInfo.companyId){
    //   this.isCompnayVisible = true;
    // }
    console.log("this.$store.getters.userInfo="+this.$store.getters.userInfo);
    console.log(this.$store.getters.userInfo);
    this._filter = {};
    this.companyId = this.$store.getters.userInfo.companyId;
    this.companyCode = this.$store.getters.userInfo.companyCode;
    console.log("this compnayCode="+this.companyCode);
    this.queryParams.companyId = this.companyId;
    this.queryParams.companyCode = this.companyCode;
    this.getSalaryTempList();
    getOrgTree((tree, companyList, departmentList, positionList )=>{
      console.log("return tree:"+tree);
      console.log(tree);
      this.companyList = companyList;
      // if(this.$store.getters.userInfo.companyId == PARENT_COMPANY_ID){
      sumTreeChild(tree,'id','pid');
      this.treeData = tree;

      this.allDepartmentOptions = [];
      const dataDepartment = { id:0,
        name:'顶级部门',
        children: []
      };
      dataDepartment.children = this.handleTree(departmentList, "id", "pid");
      this.allDepartmentOptions.push(dataDepartment);

      this.companyOptions = [];
      this.companyOptions = this.handleTree(companyList, "id", "pid");

      this.positionList = positionList;
      this.departmentList = departmentList;
      this.getList();
    });
    this.queryOfficalEmployCount(this.companyCode);
  },
  methods: {
    getSalaryTempList(companyId){
      let filter = {};
      if(companyId){
        filter['companyId'] = {
          type: 'eq',
          value: companyId,
        };
      }
      const params = this.getQueryParam(filter, 1, 1000, '');
      listCbSalaryTemplate(params).then(response => {
        console.log("getSalaryTempList");
        this.salaryTempList = response.data.records;
        console.log(this.salaryTempList);
      });
    },

    checkRole(role){
      return checkRole(role);
    },
    showRealCount(data){
      if(data.realCount){
        if(data.realCount == data.selfRealCount){
          return data.realCount;
        }else if(data.selfRealCount){
          return data.realCount + "(" + data.selfRealCount +")";
        }else{
          return data.realCount;
        }
      }else{
        return "0";
      }
    },
    /** 查询员工信息列表 */
    getQuery() {
      this._filter = {};
      if(this.queryParams.departmentId) {
        this._filter['departmentId'] = {
          type: 'eq',
          value: this.queryParams.departmentId,
        }
      }
      if(this.queryParams.name) {
        this._filter['name'] = {
          type: 'search',
          value: this.queryParams.name,
        }
      }
      // if(this.queryParams.contractSalary){
      //   this._filter['contractSalary'] = {
      //     type: 'search',
      //     value: this.queryParams.name,
      //   }
      // }
      if(this.queryParams.contractSalaryStart && this.queryParams.contractSalaryEnd) {
        this._filter['contractSalary'] = {
          type: 'range',
          value: [this.queryParams.contractSalaryStart,this.queryParams.contractSalaryEnd],
        }
      }else if(this.queryParams.contractSalaryStart) {
        this._filter['contractSalary'] = {
          type: 'ge',
          value: this.queryParams.contractSalaryStart,
        }
      }else if(this.queryParams.contractSalaryEnd) {
        this._filter['contractSalary'] = {
          type: 'le',
          value: this.queryParams.contractSalaryEnd,
        }
      }
      if (this.queryParams.workNum) {
        this._filter['workNum'] = {
          type: 'search',
          value: this.queryParams.workNum,
        }
      }
      if (this.queryParams.idNum) {
        this._filter['idNum'] = {
          type: 'search',
          value: this.queryParams.idNum,
        }
      }
      if (this.queryParams.companyCode) {
        this._filter['companyCode'] = {
          type: 'rlike',
          value: this.queryParams.companyCode,
        }
      }
      if (this.queryParams.empStatus) {
        this._filter['empStatus'] = {
          type: 'eq',
          value: this.queryParams.empStatus,
        }
      }
      if (this.queryParams.noSalary) {
        this._filter['contractSalary'] = {
          type: 'isNull',
          value: "",
        }
      }
      const filters = this.parseFilters(this._filter)
      if(this.queryParams.isShowDeleted){
        this.employeeStatuses = DICT_TYPE.employeeStatuses;
        filters.push({name: 'deleted', type: 'eq', values: [1]});
      }else{
        if(!this.queryParams.isShowDepart){
          filters.push({name: 'empStatus', type: 'notIn', values: ['离职','离退休','离岗','黑名单']})
          this.employeeStatuses = DICT_TYPE.empOnWorkStatuses;
        }else{
          this.employeeStatuses = DICT_TYPE.employeeStatuses;
        }
      }

      if (filters && filters.length > 0) {
        this.where.filters = filters
      } else {
        // 如果过滤条件为空，设置空数组
        this.where.filters = []
      }
      const params = {
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
        where: this.where,
        order: this.orderby
      }

      return params;
    },
    getList() {
      this.loading = true;
      const params = this.getQuery();
      if(this.queryParams.isShowDeleted){
        console.log("only deleted")
        listEmployIncludeDelete(params).then(response => {
          this.employList = response.data.records;
          this.total = response.data.total;
          this.loading = false;
        });
      }else{
        listEmploy(params).then(response => {
          this.employList = response.data.records;
          this.total = response.data.total;
          this.loading = false;
        });
      }
    },
    // 查询公司待转正员工数
    queryOfficalEmployCount(companyCode){
      const date = new Date();
      // countOfficalEmploy(companyCode, formatDate(date,'YYYY-mm-dd')).then(response => {
      //   this.officalCount = response.data;
      // });
    },
    /** 转换公司数据结构 */
    normalizerCompany(node) {
      return this.normalizer(node,'id','companyName');
    },

    /** 查询公司下拉树结构 */
    getDepartment(companyId) {
      getTreeselectDepartment(companyId, false, (list, options) =>{
        this.departmentList = list;
        let companyName = "";
        this.companyList.forEach(item =>{
          if(item.id == companyId){
            companyName = item.companyName;
          }
        })
        const departTree = [{ id:0,
          name: companyName,
          children: []
        }];
        departTree[0].children = options;
        this.departmentOptions = departTree;
      });
    },
    normalizerPosition(node){
      return this.normalizer(node);
    },
    /** 查询岗位下拉树结构 */
    getPositison(companyId) {
      getTreeselectPosition(companyId, false, (list, options) =>{
        this.positionList = list;
        this.positionOptions = options;
      });
    },
    positionFormat(row, column) {
      // console.log(row.positionId);
      for(var i = 0; i < this.positionList.length; i++){
        const item =  this.positionList[i];
        // console.log("id:"+item.id+",depid:"+row.departmentId+", name :"+item.name+",ee="+(item.id == row.departmentId));
        if(item.id == row.positionId){
          return item.name;
        }
      }
      return "";
    },

    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    selectCompany(val){
      console.log(val);
      console.log(val.id);
      this.queryParams.companyId = val.id;
    },
    // 节点单击事件
    handleNodeClick(data) {
      if(data.classType === 'company'){
        console.log("select company");
        console.log(data);
        if(data.id == 0){
          this.queryParams.companyCode = this.companyCode;
        }else{
          this.queryParams.companyCode = data.code;
          if(data.code.length < this.$store.getters.userInfo.companyCode.length){
            console.log("选了父公司,companyid 不赋值父公司");
          }else{
            this.companyId = data.id;
            // 查询公司待转正人员
            this.queryOfficalEmployCount(data.code);
          }
        }
        console.log("queryParams");
        console.log(this.queryParams);
        this.queryParams.departmentId = null;
      }else if(data.classType === 'department') {
        console.log("select department");
        console.log(data);
        this.queryParams.companyCode = data.companyCode;
        this.companyId = data.companyId;
        this.queryParams.departmentId = data.id;
      }
      this.getList();
    },
    salaryTempFormat(row, column) {
      for(var i = 0; i < this.salaryTempList.length; i++){
        const item =  this.salaryTempList[i];
        if(item.id == row.salaryTempId){
          return item.name;
        }
      }
      return "";
    },
    getSalaryItemInfo(row){
      if(row.salarySelfDef) {
        this.calculateFloatItem(row.salaryInfo.itemInfo, row.contractSalary, row);
        return row.salaryInfo.itemInfo;
      }
      if(!row.salaryTempId){
        return [];
      }
      let itemInfo = [];
      for(var i = 0; i < this.salaryTempList.length; i++){
        const item =  this.salaryTempList[i];
        if(item.id == row.salaryTempId){
          item.itemInfo.forEach(i=>{
            itemInfo.push({itemName:i.itemName, plusMinus:i.plusMinus, itemType:i.itemType, isAttend:i.isAttend, amount:i.amount
              ,valueType:i.valueType,refId:i.refId,refType:i.refType});
          });
          this.calculateFloatItem(itemInfo, row.contractSalary, row);
          return itemInfo;
        }
      }
      return itemInfo;
    },
    calculateFloatItem(salaryItemInfo, contractSalary, row){
      let floatItem = null;
      let val = 0;
      console.log("calculateFloatItem")
      salaryItemInfo.forEach(item=>{
        if('引用值' == item.valueType){
          // 引用值需要判断社保公积金是否需要被替换
          if('社保'==item.refType){
            console.log("社保")
            if(row.insuranceAmt && row.insuranceAmt > 0){
              item.amount = row.insuranceAmt;
            }
          }else if('住房公积金'==item.refType){
            console.log("住房公积金")
            if(row.fundAmt && row.fundAmt > 0){
              item.amount = row.fundAmt;
            }
          }
        }

        if(item.itemType == DICT_TYPE.CB_TEMPLATE_SALARY_TYPE_FLOAT){
          floatItem = item;
        }else if(item.itemType == DICT_TYPE.CB_TEMPLATE_SALARY_TYPE_SALARY){
          const value = Number(item.amount);
          if (!isNaN(value)) {
            if (item.plusMinus == '增项') {
              val += value;
            } else {
              val -= value;
            }
          }
        }
      });
      if(floatItem){
        const amount = contractSalary - val;
        this.$set(floatItem, "amount", amount);
      }
    },
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      sums[0] = '应发工资';
      let extVal = 0;
      let val = 0;
      data.map(item => {
        const value = Number(item.amount);
        if (!isNaN(value)) {
          if (item.plusMinus == '增项') {
            val += value;
          } else {
            val -= value;
          }
          if(DICT_TYPE.CB_TEMPLATE_SALARY_TYPE_EXTRA == item.itemType){
            if (item.plusMinus == '增项') {
              extVal += value;
            } else {
              extVal -= value;
            }
          }
        }
      });
      sums[4] = ""+val.toFixed(2);//+"(其中包含"+extVal+DICT_TYPE.CB_TEMPLATE_SALARY_TYPE_EXTRA+")";
      // sums[3] = "包含"+extVal+DICT_TYPE.CB_TEMPLATE_SALARY_TYPE_EXTRA+"";
      // if(this.contractSalary){
      //   sums[2] = this.contractSalary+"(合同总工资)"
      // }
      return sums;
    },
    companyFormat(row, column) {
      // console.log(row.departmentId);
      for(var i = 0; i < this.companyList.length; i++){
        const item =  this.companyList[i];
        // console.log("id:"+item.id+",depid:"+row.departmentId+", name :"+item.name+",ee="+(item.id == row.departmentId));
        if(item.id == row.companyId){
          return item.name;
        }
      }
      return "";
    },
    departmentFormat(row, column) {
      // console.log(row.departmentId);
      for(var i = 0; i < this.departmentList.length; i++){
        const item =  this.departmentList[i];
        // console.log("id:"+item.id+",depid:"+row.departmentId+", name :"+item.name+",ee="+(item.id == row.departmentId));
        if(item.id == row.departmentId){
          return item.name;
        }
      }
      return "";
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      // this.$router.replace("/");
      // this.$router.push({name:"employ_employ_add_vue", params: {companyId: this.companyId}});
      this.row = {companyId: this.companyId ,time: Date.parse(new Date())};
      this.open = true;
      this.title = "新增员工";
    },
    /** 修改按钮操作 */
    handleView(row) {
      this.employReadOnly = true;
      this.employeeInfoAdd = true; // diable button
      const id = row.id || this.ids
      getEmploy(id).then(response => {
        // this.$router.push({name:"employ_employ_edit_vue", params: {row:response.data, companyId: this.companyId}});
        this.row = response.data;
        this.open = true;
        this.title = "查阅员工信息";
      });
    },
    handleMultiSalary(row){
      const id = row.id || this.ids
      if(!id || id.length < 1){
        this.$alert('请选择要设置总工资的员工', '总工资设置');
        return;
      }
      console.log(id);
      const that = this;
      this.$prompt('请输入总工资金额', '提示', {confirmButtonText: '确定', cancelButtonText: '取消',
        inputPattern: /(^[0-9]*(\.[0-9]+)?)$/,
        inputErrorMessage: '总工资金额格式不正确'
      }).then(({ value }) => {
        updateMultiSalary({ids:id,updateType:'salary', salary:value}).then(resp =>{
          this.$message({type: 'success',message: '总工资金额设置成功'});
          that.getList();
        });
      }).catch(() => {
      });

    },
    handleMultiSalaryTemplate(row){
      const id = row.id || this.ids
      if(!id || id.length < 1){
        this.$alert('请选择要设置账套的员工', '账套设置');
        return;
      }
      let companyId = null;
      let mutiCompany = false;
      for(let e = 0; e < this.employList.length; e++){
        const item = this.employList[e];
        for(let i = 0; i < id.length; i++){
          if(item.id == id[i]){
            if(null == companyId) {
              companyId = item.companyId;
            }else if(companyId != item.companyId){
              mutiCompany = true;
            }
            break;
          }
        }
        if(mutiCompany) break;
      }
      if(mutiCompany){
        this.$alert('不能选择不同公司员工设置账套', '账套设置');
        return;
      }
      // 设置公司工资套账列表
      let list = []; //
      this.salaryTempList.forEach(item=>{
        if(item.companyId == companyId){
          list.push(item);
        }
      })
      this.salaryTempListForSetting = list;
      this.openSalaryTemplate = true;
    },
    async importSocialSecurity(params){
      const _file = params.file;
      const formData = new FormData();
      formData.append("companyId",this.$store.getters.userInfo.companyId);
      formData.append('file', _file);
      showLoading();
      importSocialSecurity(formData).then(response=>{
        console.log(response.code);
        this.$message({type: 'success',message: response.msg});
        this.fileList = [];
        this.getList();
        hideLoading();
      }).reject( ()=>{
        this.fileList = [];
        hideLoading();
      });
    },
    async importFund(params){
      const _file = params.file;
      const formData = new FormData();
      formData.append("companyId",this.$store.getters.userInfo.companyId);
      formData.append('file', _file);
      showLoading();
      importFund(formData).then(response=>{
        console.log(response.code);
        this.$message({type: 'success',message: response.msg});
        this.fileList = [];
        this.getList();
        hideLoading();
      }).reject( ()=>{
        this.fileList = [];
        hideLoading();
      });

    },
    async importSalary(params){
      const _file = params.file;
      const formData = new FormData();
      formData.append("companyId",this.$store.getters.userInfo.companyId);
      formData.append('file', _file);
      showLoading();
      importSalary(formData).then(response=>{
        console.log(response.code);
        this.$message({type: 'success',message: response.msg});
        this.fileList = [];
        this.getList();
        hideLoading();
      }).reject( ()=>{
        this.fileList = [];
        hideLoading();
      });

    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    setSalaryTemplate(){
      const id = this.ids
      if(!id || id.length < 1){
        this.$alert('请选择要设置账套的员工', '账套设置');
        return;
      }
      const that = this;
      console.log(id)
      console.log("this.salaryTemplateId="+this.salaryTemplateId);
      showLoading();
      updateMultiSalary({ids:id, updateType:'template', salaryTemplateId:this.salaryTemplateId}).then(resp =>{
        this.$message({type: 'success',message: '账设置成功'});
        this.openSalaryTemplate = false;
        hideLoading();
        that.getList();
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.employReadOnly = false;
      const id = row.id || this.ids
      getEmploy(id).then(response => {
        // this.$router.push({name:"employ_employ_edit_vue", params: {row:response.data, companyId: this.companyId}});
        this.row = response.data;
        // if(this.row.salarySelfDef&&!this.row.salaryInfo.attItems){
        //   this.row.salaryInfo.attItems = [];
        // }
        console.log(this.row.companyId);
        this.companyId = this.row.companyId;
        this.open = true;
        this.title = "薪酬设置";
      });
    },


    viewTransferHis(row){
      console.log("viewTransferHis row.userId:");
      console.log(row.userId);
      this.transferUserId = row.userId;
      this.openTransferTrace = true;
      // getTransferhisByUserId(row.userId, (list)=>{
      //   console.log("viewTransferHis return:");
      //   console.log(list);
      // });
    },
    listOffical(){
      this.loading = true;
      let filter = {};
      filter['companyCode'] = {
        type: 'rlike',
        value: this.queryParams.companyCode,
      }
      filter['empStatus'] = {
        type: 'eq',
        value: '试用',
      }
      filter['officalDate'] = {
        type: 'le',
        value: formatDate(new Date(),'YYYY-mm-dd'),
      }
      const params = getQueryParam(filter,this.queryParams.pageNum, this.queryParams.pageSize,'');
      listEmploy(params).then(response => {
        this.employList = response.data.records;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = this.getQuery();
      this.$confirm('是否确认导出所有员工信息数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return exportEmploy(params);
      }).then(response => {
        this.download(response.msg);
      })
    },

    // 提交确认后关闭对话框
    close(arg){
      this.open = false;
      if(arg.refresh){
        this.getList();
      }
    },

    update(data){

      console.log("update ******");
      console.log(data.data);
      updateEmploy(data.data).then(response => {
        this.msgSuccess("修改成功");
        this.open = false;
        this.getList();
      });
    },

    downloadSocialSecurity(){
      var a = document.createElement("a"); //创建一个<a></a>标签
      a.href = "/static/SocialSecurityTemplate.xls"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = "社保模板.xls"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
      //fileDownload(this.templateClockTime,download);
    },

    downloadFund(){
      var a = document.createElement("a"); //创建一个<a></a>标签
      a.href = "/static/FundsTemplate.xls"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = "公积金模板.xls"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
      //fileDownload(this.templateClockTime,download);
    },

    downloadSalarySetting(){
      var a = document.createElement("a"); //创建一个<a></a>标签
      a.href = "/static/SalarySettingTemplate.xls"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = "薪资设置模板.xls"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
      //fileDownload(this.templateClockTime,download);
    },

  }
};
</script>
<style scoped>
  .input-number-range {
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

</style>
